document.addEventListener('DOMContentLoaded', function() {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-accordion-image]').forEach(function(section) {
    if (reduceMotion) {
      section.querySelectorAll('[data-accordion-content]').forEach(function(c) {
        c.classList.remove('twcss-transition-all', 'twcss-duration-300');
      });
      section.querySelectorAll('[data-accordion-img]').forEach(function(img) {
        img.classList.remove('twcss-transition-opacity', 'twcss-duration-500');
      });
      section.querySelectorAll('[data-accordion-trigger] svg').forEach(function(svg) {
        svg.classList.remove('twcss-transition-transform', 'twcss-duration-300');
      });
    }

    var triggers = section.querySelectorAll('[data-accordion-trigger]');
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var idx = this.getAttribute('data-accordion-trigger');
        var isOpen = this.getAttribute('aria-expanded') === 'true';

        if (isOpen) return;

        section.querySelectorAll('[data-accordion-content]').forEach(function(c) {
          c.hidden = true;
        });
        section.querySelectorAll('[data-accordion-trigger]').forEach(function(t) {
          t.setAttribute('aria-expanded', 'false');
          t.querySelector('svg').style.transform = '';
        });
        section.querySelectorAll('[data-accordion-img]').forEach(function(img) {
          img.style.opacity = '0';
          img.setAttribute('aria-hidden', 'true');
        });

        var content = section.querySelector('[data-accordion-content="' + idx + '"]');
        if (content) {
          content.hidden = false;
        }
        this.setAttribute('aria-expanded', 'true');
        this.querySelector('svg').style.transform = 'rotate(180deg)';

        var img = section.querySelector('[data-accordion-img="' + idx + '"]');
        if (img) {
          img.style.opacity = '1';
          img.setAttribute('aria-hidden', 'false');
        }
      });
    });
  });
});

